export const MESSAGES_KEY = "user_history";
export const CONTACTS_REQUIRED_KEY = "contacts_required_session_id";
export const MAX_MESSAGES_COUNT = 100;

export const DEFAULT_FIRST_MESSAGE = 'Привіт! Я Майя, помічниця MyCredit. Чим я можу бути корисною для Вас?';

export const AI_SURVEY_MESSAGE = 'Хочу бути корисною 🙂. Тому прошу оцінити, наскільки легко Вам було вирішити питання , де 1 - дуже важко, а 10 - надзвичайно легко';
export const AI_SURVEY_FINAL_MESSAGE = 'Дякую за Вашу оцінку☺️';

export const SHARE_CONTACT_MESSAGE = 'Дякуємо, що поділились контактом🫡'
